import { ReactNode } from "react";
import { Symbols } from "./type";
import BigNumber from "bignumber.js";

const HippoSplashUtils = {
  takeSymbol(reelMatrix: number[][], x: number, y: number): number {
    return reelMatrix[x][y];
  },
  convertSymbol(symbol: number, key?: string): ReactNode {
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case Symbols.Symbol1:
        return <img key={key} alt="Spades" src="/hp/201.png" />;
      case Symbols.Symbol2:
        return <img key={key} alt="Hearts" src="/hp/202.png" />;
      case Symbols.Symbol3:
        return <img key={key} alt="Clubs" src="/hp/203.png" />;
      case Symbols.Symbol4:
        return <img key={key} alt="Diamonds" src="/hp/204.png" />;
      case Symbols.Symbol5:
        return <img key={key} alt="Ace" src="/hp/205.png" />;
      case Symbols.Symbol6:
        return <img key={key} alt="King" src="/hp/206.png" />;
      case Symbols.Wild:
        return <img key={key} alt="Wild" src="/hp/21.png" />;
      case -1:
        return <></>;
      default:
        return symbol;
    }
  },
  convertPayline(payline: string, key?: string): ReactNode {
    if (Number.isNaN(payline)) return "";
    switch (payline) {
      case "1":
        return <img key={key} alt="1" src="/hp/1.png" />;
      case "2":
        return <img key={key} alt="2" src="/hp/2.png" />;
      case "3":
        return <img key={key} alt="3" src="/hp/3.png" />;
      case "4":
        return <img key={key} alt="4" src="/hp/4.png" />;
      case "5":
        return <img key={key} alt="5" src="/hp/5.png" />;
      default:
        return payline;
    }
  },
  takeSymbolsByPayline(reelMatrix: number[][], paylineId: string): number {
    switch (paylineId) {
      case "1":
        return this.chooseValidSymbolId([
          reelMatrix[0][1],
          reelMatrix[1][1],
          reelMatrix[2][1],
        ]);
      case "2":
        return this.chooseValidSymbolId([
          reelMatrix[0][0],
          reelMatrix[1][0],
          reelMatrix[2][0],
        ]);
      case "3":
        return this.chooseValidSymbolId([
          reelMatrix[0][2],
          reelMatrix[1][2],
          reelMatrix[2][2],
        ]);
      case "4":
        return this.chooseValidSymbolId([
          reelMatrix[0][0],
          reelMatrix[1][1],
          reelMatrix[2][2],
        ]);
      case "5":
        return this.chooseValidSymbolId([
          reelMatrix[0][2],
          reelMatrix[1][1],
          reelMatrix[2][0],
        ]);
      default:
        throw new Error("Invalid paylineId");
    }
  },
  chooseValidSymbolId(symbols: number[]): number {
    const validSymbolId = symbols.filter(this.isValidSymbol);
    if (validSymbolId.length > 0) return validSymbolId[0];
    const wild = symbols.filter(this.isWildSymbol);
    if (wild.length > 0) return wild[0];
    return symbols[0];
  },
  isValidSymbol(symbol: number): boolean {
    return symbol >= 201 && symbol <= 206;
  },
  isWildSymbol(symbol: number): boolean {
    return symbol === Symbols.Wild;
  },
  symbolPayout(symbol: number) {
    const payout = {
      [Symbols.Wild]: 250,
      [Symbols.Symbol1]: 100,
      [Symbols.Symbol2]: 25,
      [Symbols.Symbol3]: 10,
      [Symbols.Symbol4]: 8,
      [Symbols.Symbol5]: 5,
      [Symbols.Symbol6]: 3,
    } as Record<number, number>;
    return payout[symbol] || 0;
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount);
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount)
      .multipliedBy(0.2) // bet size
      .multipliedBy(5) // 5 lines
      .multipliedBy(10) // bonus multiplier
      .multipliedBy(250); // symbol payout
  },
} as const;

export default HippoSplashUtils;
